export default {"src":"/fly/_next/static/media/passenger-white.aae912bf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};